/**
 * Pull every page for a paged RTK Query endpoint so exports cover the WHOLE filtered dataset,
 * not just the rows scrolled into view. The backend clamps PageSize to 200, so we loop.
 *
 * @param {Function} trigger  an RTK lazy-query trigger: (args) => ({ unwrap() })
 * @param {object}   filter   the active filter (without page/pageSize)
 * @param {number}   pageSize page size per request (<=200)
 * @returns {Promise<object[]>} all items across pages, in server order
 */
export async function fetchAllPages(trigger, filter = {}, pageSize = 200) {
  const all = [];
  let page = 1;
  // Hard ceiling to avoid runaway loops on unexpected responses.
  for (let guard = 0; guard < 1000; guard += 1) {
    // eslint-disable-next-line no-await-in-loop
    const res = await trigger({ ...filter, page, pageSize }).unwrap();
    const items = res?.items ?? [];
    all.push(...items);
    const total = res?.totalCount ?? all.length;
    if (all.length >= total || items.length === 0) break;
    page += 1;
  }
  return all;
}
